import { normalizeCouponLang } from '../i18n/couponLocale';

export function resolveCouponName(item, lang) {
  if (!item) return '';
  const isEn = normalizeCouponLang(lang) === 'en';
  const en = String(item.nameEn ?? item.NAME_EN ?? '').trim();
  const base = String(item.name ?? item.NAME ?? '').trim();
  return (isEn && en) ? en : base;
}

export function resolveCouponDescription(item, lang) {
  if (!item) return '';
  const isEn = normalizeCouponLang(lang) === 'en';
  const en = String(item.descriptionEn ?? item.DESCRIPTION_EN ?? '').trim();
  const base = String(item.description ?? item.DESCRIPTION ?? '').trim();
  return (isEn && en) ? en : base;
}
